var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChristmasTreeOrnamentsGift = function SvgChristmasTreeOrnamentsGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "-0.75 -0.75 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.36 15.577-2.009-2.985a.478.478 0 0 1 .401-.767h1.071a.478.478 0 0 0 .418-.746L9.844 6.33h2.11L8.155.916a.515.515 0 0 0-.835 0L3.517 6.328h2.108l-4.219 5.625H4.22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.219 11.953.804 17.514a.478.478 0 0 0 .403.767h11.45m-4.922 0v3.516M4.603 7.692l5.76-.64m-7.017 6.324 8.005-.784m9.275 3.58h-4.688a.47.47 0 0 0-.468.469v4.687a.47.47 0 0 0 .468.469h4.688a.47.47 0 0 0 .469-.469v-4.687a.47.47 0 0 0-.47-.47zm-2.344 0v5.625m-2.812-2.813h5.625m-2.813-2.812-1.406-2.11m2.812.001-1.406 2.109M11.25.703c3.485 1.209 7.668 1.856 10.546 1.406m-1.404.144v2.669m-.002 2.812a1.406 1.406 0 1 0 0-2.812 1.406 1.406 0 0 0 0 2.812m-4.92-5.915v1.697m0 2.812a1.406 1.406 0 1 0 0-2.812 1.406 1.406 0 0 0 0 2.812"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M5.977 10.547a.352.352 0 0 1 0-.703m0 .703a.352.352 0 0 0 0-.703m3.516.33a.352.352 0 1 1 0-.703m0 .703a.352.352 0 0 0 0-.703m-3.516 6.701a.352.352 0 0 1 0-.703m0 .703a.352.352 0 0 0 0-.703m3.516.703a.352.352 0 1 1 0-.703m0 .703a.352.352 0 0 0 0-.703"
  })));
};
export default SvgChristmasTreeOrnamentsGift;